import React from 'react';
import { Container, Col, Row } from 'reactstrap';
import BreadCrumb from '../../Components/Commons/BreadCrumb';
import WebServiceSummary from "./WebServiceSummary";
import WebServiceStatistics from "./WebServiceStatistics";
import { useTranslation, initReactI18next } from "react-i18next";

const WebServiceDetail = () => {

	const { t } = useTranslation();

	document.title = t("WebService Data Replication");

	return (
		<React.Fragment>
			<div className="page-content">
				<Container fluid>
					<BreadCrumb title={t("Web Service Details")} pageTitle={t("Web Services")} />
					<Row>
						<Col xxl={6}>
							<WebServiceSummary />
						</Col>
						<WebServiceStatistics />
					</Row>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default WebServiceDetail;